const url = 'https://v-meet-api.onrender.com'
// const url = 'https://v-meet-api.herokuapp.com'

export default url
